import { render } from "./AdminLoading.vue?vue&type=template&id=77b274be&scoped=true"
import script from "./AdminLoading.vue?vue&type=script&lang=js"
export * from "./AdminLoading.vue?vue&type=script&lang=js"

import "./AdminLoading.vue?vue&type=style&index=0&id=77b274be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b274be"]])

export default __exports__